import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { RouteError } from '../components/route-errors';
import { ADMIN_EMAILS } from '../hooks/admin-access';
import { authenticatedLayout } from './authenticated';

// ---------------------------------------------------------------------------
// Admin layout (/admin) — admin email check, top-level (cross-store)
// ---------------------------------------------------------------------------

const adminLayout = createRoute({
  getParentRoute: () => authenticatedLayout,
  path: '/admin',
  component: lazyRouteComponent(() => import('../pages/admin/index'), 'AdminLayout'),
  errorComponent: RouteError,
  beforeLoad: ({ context }) => {
    const email = context.auth.user?.email;
    if (!email || !ADMIN_EMAILS.includes(email)) {
      throw redirect({ to: '/' });
    }
  },
});

const adminIndexRoute = createRoute({
  getParentRoute: () => adminLayout,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/admin/onboarding' });
  },
});

const pricingRoute = createRoute({
  getParentRoute: () => adminLayout,
  path: '/pricing',
  component: lazyRouteComponent(() => import('../pages/admin/pricing'), 'PricingTab'),
});

const releasesRoute = createRoute({
  getParentRoute: () => adminLayout,
  path: '/releases',
  component: lazyRouteComponent(() => import('../pages/admin/releases'), 'ReleasesTab'),
});

const onboardingOverviewRoute = createRoute({
  getParentRoute: () => adminLayout,
  path: '/onboarding',
  component: lazyRouteComponent(
    () => import('../pages/admin/onboarding/overview'),
    'OnboardingOverviewTab'
  ),
});

const onboardingTimelineRoute = createRoute({
  getParentRoute: () => adminLayout,
  path: '/onboarding/$storeId',
  component: lazyRouteComponent(
    () => import('../pages/admin/onboarding/timeline'),
    'OnboardingTimelineTab'
  ),
});

export const adminRoutes = adminLayout.addChildren([
  adminIndexRoute,
  pricingRoute,
  releasesRoute,
  onboardingOverviewRoute,
  onboardingTimelineRoute,
]);
